<template>
  <section class="contacts">
    <img class="contacts__img " src="~@/assets/images/open-7days.png" alt="" />
    <div class="open-text"><strong> 7 днів на тиждень</strong></div>
    <div class="order">
      Замовлення приймаємо<br /><strong>З 11:00 до 21:30</strong>
    </div>
    <br />
    <div class="address">
      <div class="address__title-wrapper">
        <i class="fa fa-map"></i>
        <div>Наша адресса:</div>
      </div>
      <br />
      <div class="address_text-wrapper">
        <div>смт.Стрижавка, ЖК "Затишна Фазенда" вул Алеї, 35/1</div>
      </div>
      <div class="address_map-wrapper">
        <iframe
          title="location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2601.4249632049496!2d28.463202143622933!3d49.306235285386855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x472d430ab953fe5f%3A0x21c2ccdad11a2fb6!2zIkF2b2NhZG8i!5e0!3m2!1sru!2sua!4v1623752917871!5m2!1sru!2sua"
          width="100%"
          height="450"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
    <br />
    <div class="phone">
      <div class="phone-wrapper">
        <div class="phone__title">
          <i class="fa fa-phone"></i>
          <div>Замовляйте по телефону:</div>
        </div>
        <div>
          <ul class="phone__list">
            <li class="phone_item">
              <a href="tel:+380977005515">+38 097 700 55 15</a>
            </li>
            <li class="phone_item">
              <a href="tel:+380737005515">+38 073 700 55 15</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <br />
    <div class="email">
      <div class="email__title-wrapper">
        <i class="fa fa-envelope-open"></i>
        <div>Наш Email:</div>
      </div>
      <br />
      <div class="address_text-wrapper">
        <a href="mailto:avocado.sushi.strizhavka@gmail.com"
          >avocado.sushi.strizhavka@gmail.com</a
        >
      </div>
    </div>
    <br />
    <br />
    <div class="social">
      <div class="social__title-wrapper">
        <i class="fa fa-users"></i>
        <div>Ми в соц.мережах:</div>
      </div>
      <ul class="social__link-wrapper">
        <li class="facebook">
          <a target="_blank" href="https://www.facebook.com/" title="facebook">
            <i class="fab fa-facebook" aria-hidden="true"></i>
          </a>
        </li>
        <li class="instagram">
          <a
            target="_blank"
            href="https://www.instagram.com/avocadosushi_strizhavka"
            title="instagram"
          >
            <i class="fab fa-instagram" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>
<style lang="scss" scoped>
i {
  margin-right: 10px;
}
.contacts {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: black;
  font-size: large;
  color: white;
  min-height: 100vh;
  justify-content: center;
  padding: 10vh 0;
}
.contacts__img {
  height: 150px;
}
.open-text {
  color: #c62b2b;
  font-style: normal;
  font-size: x-large;
  text-transform: uppercase;
  margin: 0vh 0 4vh 0;
}
.order {
  font-size: 1.5em;
  color: white;
  font-family: inherit;
  color: green;
}
.email {
  display: flex;
  flex-direction: column;
}
.email__title-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.address {
  display: flex;
  flex-direction: column;
  margin-top: 10vh;
  width: 100%;
  align-items: center;
}
.address__title-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.address_map-wrapper {
  width: 80%;
  margin-top: 4vh;
}
.phone {
  padding: 5vh 0;
}
.phone__title {
  display: flex;
  flex-direction: row;
}
.phone__list {
  padding: 0;
  margin: 1vh;
}
.social {
  display: flex;
  flex-direction: column;
  padding: 2vh 0 0;
}
.social__title-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.social__link-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0;
  font-size: 1.5em;
  margin: 1vh;
}
@media (max-width: 767px) {
  .contacts {
    font-size: inherit;
  }
  .contacts__img {
    height: 100px;
  }
  .open-text {
    font-size: initial;
  }
  .address_map-wrapper {
    width: 100%;
  }
}
</style>
